var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('div',{staticClass:"layout-header-wrap"},[_c('HeaderOperation'),_c('HeaderMenu')],1),_c('div',{staticClass:"body-wrap"},[_c('router-view'),_c('FooterInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }